import Menu from './menu';
import type { MenuProps } from './menu';
import type { ItemType } from './menu.utils';

export { MenuProps, ItemType as MenuItemType };
export default Menu;
